// extracted by mini-css-extract-plugin
export var regionPopup = "MapRegionPopup-module--regionPopup--QErYi";
export var regionPopup__closeBtn = "MapRegionPopup-module--regionPopup__closeBtn--hZxte";
export var regionPopup__visuallyHiddenEl = "MapRegionPopup-module--regionPopup__visuallyHiddenEl--DTkvp";
export var place = "MapRegionPopup-module--place--PFTpu";
export var place__title = "MapRegionPopup-module--place__title--tizl0";
export var place__markers = "MapRegionPopup-module--place__markers--GJfBy";
export var place__marker = "MapRegionPopup-module--place__marker--8o48a";